module.exports = __webpack_public_path__ + "static/media/direction icon.8f30ad90.svg";